import gql from 'graphql-tag';
import { TAG_DETAILS_FRAGMENT } from './fragments';

const getTagsForResourceQuery = gql`
  query GetTagsForResource($resourceId: ID!) {
    getTagsForResource(resourceId: $resourceId) {
      ...TagDetails
    }
  }
  ${TAG_DETAILS_FRAGMENT}
`;

export default {
  query: getTagsForResourceQuery,
  module: 'tags',
  ignoreCache: true,
  buildVariables: ({ assetId }) => ({
    resourceId: assetId
  })
};